/**
 * 图片拖拽/缩放/旋转 composable
 */
import { ref } from 'vue';

export function useImageViewer() {
  const imgRef = ref(null);
  const isDragging = ref(false);
  const styleObj = ref({});
  const startX = ref(0);
  const startY = ref(0);
  const endX = ref(0);
  const endY = ref(0);
  const savedEndX = ref(0);
  const savedEndY = ref(0);
  const rotation = ref(0);
  const scale = ref(1);

  const updateStyle = () => {
    styleObj.value = `transform: scale(${scale.value}) rotateZ(${rotation.value}deg);left:${endX.value}px;top:${endY.value}px`;
  };

  const start = (e) => {
    e.preventDefault();
    isDragging.value = true;
    if (e.buttons) {
      startX.value = e.clientX;
      startY.value = e.clientY;
      updateStyle();
    }
  };

  const move = (e) => {
    e.preventDefault();
    if (isDragging.value) {
      endX.value = e.clientX - startX.value + savedEndX.value;
      endY.value = e.clientY - startY.value + savedEndY.value;
      updateStyle();
    }
  };

  const stop = (e) => {
    e.preventDefault();
    isDragging.value = false;
    savedEndX.value = endX.value;
    savedEndY.value = endY.value;
  };

  const mouseenter = (e) => {
    e.preventDefault();
    isDragging.value = false;
    savedEndX.value = endX.value;
    savedEndY.value = endY.value;
  };

  const mousewheel = (e) => {
    e.preventDefault();
    if (e.wheelDelta > 0) {
      scale.value = scale.value + 0.1;
    } else {
      scale.value = scale.value > 0.5 ? scale.value - 0.1 : 0.5;
    }
    updateStyle();
  };

  const zoom = (direction) => {
    if (direction === 'in') {
      scale.value = scale.value + 0.1;
    } else if (direction === 'out' && scale.value > 0.5) {
      scale.value = scale.value - 0.1;
    }
    updateStyle();
  };

  const rotate = (direction) => {
    rotation.value += direction === 'left' ? -90 : 90;
    updateStyle();
  };

  const reset = () => {
    scale.value = 1;
    rotation.value = 0;
    endX.value = 0;
    endY.value = 0;
    savedEndX.value = 0;
    savedEndY.value = 0;
    updateStyle();
  };

  return {
    imgRef,
    styleObj,
    start,
    move,
    stop,
    mouseenter,
    mousewheel,
    zoom,
    rotate,
    reset
  };
}
